import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-activity-type-header',
  templateUrl: './activity-type-header.component.html',
  styleUrls: ['./activity-type-header.component.css']
})
export class ActivityTypeHeaderComponent implements OnInit {

  @Input() type!: string;

  constructor() { }

  ngOnInit(): void {
  }

}
